const knownProjectSubroutes = new Set([
  'list',
  'timeline',
  'all',
  'types',
  'templates',
  'latest',
  'new-list',
  'new-timeline',
  'external',
  'overview'
])

/**
 * Masks a url to get rid of all ids and entity keys, to be groupable for tracking etc.
 * @param {string} url
 * @returns {string}
 */
export function maskUrl(url: string): string {
  url = url.replace(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[[0-9a-f]{4}-[0-9a-f]{12}/gi, '{id}')

  url = url.replace(/[A-Z][A-Z0-9]*(?:-[A-Z][A-Z0-9]*)*-\d+/g, '{id}')

  url = url.replace(/(\/projects\/(?:external\/)?)([^/?#)/]+)/g, (match, prefix: string, segment: string) => {
    if (segment === '{id}' || knownProjectSubroutes.has(segment)) {
      return match
    }

    return `${prefix}{id}`
  })

  const parameterIndex = url.search(/[?#]/)

  if (parameterIndex >= 0) {
    url = url.substring(0, parameterIndex)
  }

  return url
}

/**
 * Returns true when the hostname belongs to a runner instance.
 * @param {string} hostname
 * @returns {boolean}
 */
export function isRunnerHostname(hostname: string): boolean {
  return hostname.includes('.runner.')
}

/**
 * Returns true when the hostname belongs to cwork.
 * @param {string} hostname
 * @returns {boolean}
 */
export function isCworkHostname(hostname: string): boolean {
  return hostname === 'cwork.io' || hostname.endsWith('.cwork.io')
}

/**
 * Returns true when the hostname is localhost or loopback.
 * @param {string} hostname
 * @returns {boolean}
 */
export function isLocalhostHostname(hostname: string): boolean {
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '[::1]'
}

/**
 * Returns true when the hostname is an IPv4 address.
 * @param {string} hostname
 * @returns {boolean}
 */
export function isIPv4Hostname(hostname: string): boolean {
  return /^\d+\.\d+\.\d+\.\d+$/.test(hostname)
}
